// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2DP8Q","amount":"Amount_amount__27d6l","tip":"Amount_tip__2M6sQ","tipHeader":"Amount_tipHeader__2G37H","tipsWrap":"Amount_tipsWrap__3Cu-n"};